/* eslint-disable no-new */
/* eslint-disable no-cond-assign */
/* eslint-disable array-callback-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable prettier/prettier */
/* eslint-disable object-shorthand */
/* eslint-disable func-names */

import { formatDate, Manufacturer } from 'helpers/utils';
import { API } from 'helpers/api';
import Vue from 'vue/dist/vue.min';

const libraryFactory = (value) => {
    return `ParentId eq ${value}`;
};

const paginationFactory = (view) => {
    return {
        items: { total: 1, view, current: 1 },
        pages: {
            current: 1,
            total: 0,
            collection: [{ number: 1, active: true }],
        },
    };
};

const queryFactory = (view) => {
    const pagination = paginationFactory(view);
    const filter = '';
    return {
        filter,
        skip: (pagination.pages.current - 1) * pagination.items.view,
        count: true,
        orderBy: null,
        top: pagination.items.view,
        expand: ['BrandLogo'],
    };
};

const state = {
    libraryQuery: '',
    query: queryFactory(10),
};

Vue.component('tools-resources', {
    template: '#table-template',
    props: {
        title: String,
        documents: Array,
        columns: Array,
        searchQuery: String,
        pagination: Object,
        brands: Array,
        brand: Object,
    },
    filters: {},
    methods: {
        capitalize: (value) => {
            const strArr = value.split('_');
            let cap = '';
            for (let i = 0; i < strArr.length; i++) {
                if (i > 0) {
                    cap += ' ' + strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
                } else {
                    cap += strArr[i].charAt(0).toUpperCase() + strArr[i].slice(1);
                }
            }
            return cap;
        },
        date: function (date) {
            return formatDate(date);
        },
        updateDocumentsList: async function (query) {
            if (!query.filter.includes(state.libraryQuery)) query.filter += state.libraryQuery;

            const res = await API.clientservice.getDocuments(query, this.pagination);
            res.data.forEach((doc) => {
                let urlSplit = doc.Url.split('https://');
                doc.Url = `https://${urlSplit[1]}`;
            });
            this.documents = res.data || [];
            this.pagination = res.pagination;
        },
        search: async function (event) {
            if (
                (event.type === 'click' && this.searchQuery) ||
                (event.type === 'keydown' && event.keyCode === 13)
            ) {
                state.query.skip = 0;
                this.pagination.pages.current = 1;
                state.query.filter = '';
                state.query.filter = `contains(Title, '${this.searchQuery}') and `;
                await this.updateDocumentsList(state.query);
            }
        },
        dropDown: async function (event) {
            const dropdowns = document.querySelectorAll('[id^="dropdown-"]');
            state.query.filter = '';
            for (let i = 0; i < dropdowns.length; i++) {
                if (dropdowns[i].classList.contains('--active'))
                    dropdowns[i].classList.remove('--active');
            }
            state.query.skip = 0;
            this.pagination.pages.current = 1;
            switch (event.target.parentElement.getAttribute('filter')) {
                case 'brand':
                    state.query.filter = `contains(ManufacturerCode , '${event.target.parentElement.dataset.mancode}') and `;
                    await this.updateDocumentsList(state.query);
                    break;
                case 'file_type':
                    state.query.filter = `contains(Extension, '${event.target.parentElement.dataset.type}') and `;
                    await this.updateDocumentsList(state.query);
                    break;
                default:
            }
        },
        animateDropDown: function (event) {
            const dropdowns = document.querySelectorAll('[id^="dropdown-"]');
            for (let i = 0; i < dropdowns.length; i++) {
                const target = dropdowns[i].parentElement.getBoundingClientRect();
                dropdowns[i].setAttribute(
                    'style',
                    `top: ${target.top + target.height}px; 
            left: ${target.left}px;`,
                );
            }
            for (let i = 0; i < dropdowns.length; i++) {
                if (dropdowns[i].classList.contains('--active'))
                    dropdowns[i].classList.remove('--active');
                else if (dropdowns[i].id === event.target.dataset.target) {
                    dropdowns[i].classList.add('--active');
                } else if (dropdowns[i].id === event.target.parentElement.dataset.target) {
                    dropdowns[i].classList.add('--active');
                }
            }
            document.addEventListener('click', (event) => {
                const dropdowns = document.querySelectorAll('[id^="dropdown-"]');
                for (let i = 0; i < dropdowns.length; i++) {
                    if (
                        dropdowns[i].classList.contains('--active') &&
                        !(event.target.dataset.target || event.target.parentElement.dataset.target)
                    )
                        dropdowns[i].classList.remove('--active');
                }
            });
        },
        sortBy: async function (event) {
            let orderBy = '';
            const arrow = event.target.parentElement.querySelector('.fas');
            const arrows = document.querySelectorAll(
                '.list-grid__results__header-title > .fas.fa-caret-down',
            );
            const sort = event.target.parentElement.querySelector('[sort]')
                ? event.target.parentElement.querySelector('[sort]').getAttribute('sort')
                : event.target.parentElement.getAttribute('sort');
            // switch (sort) {
            //   case 'title':
            //     orderBy = 'Title'
            //     break
            //   case 'date':
            //     orderBy = 'LastModified'
            //     break
            //   default:
            // }
            if (sort === 'title') {
                orderBy = 'Title';
            } else {
                orderBy = document
                    .querySelector('.list-grid__container')
                    .dataset.dateSort.includes('expiration_date')
                    ? 'expiration_date'
                    : 'LastModified';
            }
            state.query.orderBy = state.query.orderBy
                ? state.query.orderBy.filter((value) => {
                      return !value.includes(orderBy);
                  })
                : [];
            if (arrow.classList.contains('fa-caret-up')) {
                arrows.forEach((value) => {
                    value.classList.remove('fa-caret-down');
                    value.classList.add('fa-caret-up');
                });
                state.query.orderBy = [`${orderBy} desc`];
                arrow.classList.remove('fa-caret-up');
                arrow.classList.add('fa-caret-down');
            } else {
                arrows.forEach((value) => {
                    value.classList.remove('fa-caret-down');
                    value.classList.add('fa-caret-up');
                });
                state.query.orderBy = [`${orderBy} asc`];
            }
            state.query.skip = 0;
            this.pagination.pages.current = 1;
            await this.updateDocumentsList(state.query);
        },
        handlePagination: async function (event) {
            if (Number.isNaN(parseInt(event.target.innerHTML, 10))) {
                this.pagination.pages.current =
                    event.target.getAttribute('direction') === 'increment'
                        ? this.pagination.pages.current === this.pagination.pages.total
                            ? this.pagination.pages.current
                            : this.pagination.pages.current + 1
                        : this.pagination.pages.current === 1
                        ? this.pagination.pages.current
                        : this.pagination.pages.current - 1;
            } else {
                this.pagination.pages.current = parseInt(event.target.innerHTML, 10);
            }
            state.query.skip = (this.pagination.pages.current - 1) * this.pagination.items.view;
            await this.updateDocumentsList(state.query);
        },
    },
});

const cleanEmptyFromArray = (arr) => {
    const cleanArr = [];
    for (let i = 0; i < arr.length; i++) {
        if (arr[i]) cleanArr.push(arr[i].trim());
    }
    return cleanArr;
};

document.addEventListener('DOMContentLoaded', async function () {
    const widget = document.querySelector('#documents-widget');
    if (widget) {
        let libraries = document
            .querySelector('#documents-widget')
            .getAttribute('libraryId')
            .split(';');
        libraries = cleanEmptyFromArray(libraries);
        state.libraryQuery = '(';
        for (let i = 0; i < libraries.length; i++) {
            if (libraries[i]) state.libraryQuery += `${libraryFactory(libraries[i])}`;
            if (i < libraries.length - 1) state.libraryQuery += ` or `;
        }
        state.libraryQuery += ')';
        state.query.filter = state.libraryQuery;
        new Vue({
            el: '#documents-widget',
            data: {
                searchQuery: '',
                columns: ['brand', 'title', 'file_type', 'date', 'download'],
                documents: [],
                type: '',
                title: 'technical_documents',
                filter: '',
                key: '',
                doc: {
                    Id: '',
                    LastModified: '',
                    PublicationDate: '',
                    ExpirationDate: '',
                    Title: '',
                    Description: '',
                    DateCreated: '',
                    Ordinal: 0,
                    UrlName: '',
                    Author: '',
                    Extension: '',
                    MimeType: '',
                    TotalSize: 0,
                    Parts: '',
                    FolderId: '',
                    ParentId: '',
                    Url: '',
                    ThumbnailUrl: '',
                    BrandLogo: {
                        Id: '',
                        LastModified: '',
                        PublicationDate: '',
                        ExpirationDate: '',
                        Title: '',
                        Description: '',
                        DateCreated: '',
                        Ordinal: 0,
                        UrlName: '',
                        Author: '',
                        Extension: '',
                        MimeType: '',
                        TotalSize: 0,
                        Parts: '',
                        FolderId: '',
                        ParentId: '',
                        Url: '',
                        ThumbnailUrl: '',
                    },
                },
                sort: '',
                pagination: paginationFactory(10),
                brands: [],
                brand: { mancode: 'BS', description: 'Briggs &amp; Stratton' },
                defaultSort: '',
            },
            created: async function () {
                const query = queryFactory();
                query.select = ['ManufacturerCode'];
                query.filter = state.libraryQuery;
                const res2 = await API.clientservice.getDocuments(query);
                const manufacturer = new Manufacturer();
                this.brands = manufacturer.All.filter((brand) => {
                    for (let i = 0; i < res2.data.length; i++) {
                        if (brand.ManufacturerCode === res2.data[i].ManufacturerCode) return true;
                    }
                });

                if (document.querySelector('#defaultOrderBy')) {
                    state.query.orderBy = [];
                    state.query.orderBy.push(
                        document.querySelector('#defaultOrderBy').dataset.defaultSort,
                    );
                }
                const res = await API.clientservice.getDocuments(state.query, this.pagination);
                res.data.forEach((doc) => {
                    let urlSplit = doc.Url.split('https://');
                    doc.Url = `https://${urlSplit[1]}`;
                });
                this.documents = res.data;
                this.pagination = res.pagination;
                console.log(this.documents);
            },
        });
    }
});



// WEBPACK FOOTER //
// ./app/js/modules/document-list.js